import { message } from 'antd';
import { takeLatest, put, select, delay } from 'redux-saga/effects';
import { updateSpaceTabInSpaces } from 'data/templates/projects/slices';
import { logger } from 'services';
import { updateDocumentTemplateAction } from '../actions';
import { normalizeTemplatePayload } from '../api/transform';
import { getDocumentById } from '../selectors';
import { updateDocumentTemplate } from '../slices';
import { saveDocumentTemplate } from './_save-template';
function* updateDocumentTemplateSaga(action) {
    const { payload: { spaceId, spaceTab, sync, template, handleAlways, handleFailure, handleSuccess } } = action;
    try {
        const document = yield select(getDocumentById(template.templateId));
        let documentTemplate = {
            ...document,
            ...template
        };
        yield put(updateDocumentTemplate(documentTemplate));
        if (spaceId && spaceTab) {
            yield put(updateSpaceTabInSpaces({
                spaceTab: {
                    ...spaceTab,
                    spaceTabTitle: documentTemplate.templateName || ''
                },
                spaceId
            }));
        }
        yield delay(2000);
        documentTemplate = yield saveDocumentTemplate(template.templateId, sync);
        const { entities: { template: updatedPayload } } = normalizeTemplatePayload(documentTemplate);
        yield put(updateDocumentTemplate(updatedPayload[template.templateId]));
        if (handleSuccess) {
            handleSuccess(documentTemplate);
        }
    } catch (error) {
        logger.error('an error updating the document template', {
            error
        });
        message.error('There was an error updating the document template');
        if (handleFailure) {
            handleFailure();
        }
    }
    if (handleAlways) {
        handleAlways();
    }
}
export function* watchUpdateDocumentTemplateSaga() {
    yield takeLatest(updateDocumentTemplateAction.type, updateDocumentTemplateSaga);
}
